export const APP_VERSION = '20261104-344bdf4';